import { render, staticRenderFns } from "./RestockList.vue?vue&type=template&id=5c3b9c2e&"
import script from "./RestockList.vue?vue&type=script&lang=ts&"
export * from "./RestockList.vue?vue&type=script&lang=ts&"
import style0 from "./RestockList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports